import { useCallback, useState } from 'react';
import type { LaboratoryStorageData } from '../../../native-module';

// useLaboratorySetting.ts 의 DEFAULT_VALUES 와 sync 필요
const DEFAULT_VALUES: Record<keyof LaboratoryStorageData, boolean> = {
  IS_TOUCH_VIBRATION: false,
  IS_LIKE_FOLDER: false,
  IS_GIF_IMAGE: true,
  IS_SELECT_GOODS_SCREEN_SHOT_SHARE: true,
  IS_HOME_LIVE_PREVIEW: true,
};

export const useLaboratorySetting = (key: keyof LaboratoryStorageData) => {
  const [isOn, setIsOn] = useState<boolean | undefined>(undefined);
  const loadValue = useCallback(
    async (): Promise<boolean> => DEFAULT_VALUES[key],
    [key],
  );
  return { isOn, setIsOn, loadValue };
};
